<template>
  <div id="app" class="container">
    <div class="page-wrapper">
      <div id="nav-btn" class="nav-btn">
        <span class="nav-btn-cover">
          <span class="menu-line"></span>
        </span>
      </div>
      <nav-header></nav-header>
      <page-home></page-home>
      <page-service></page-service>
      <page-about></page-about>
      <page-portfolio></page-portfolio>
      <page-blog></page-blog>
      <page-skills v-on:scroll="move('skills')"></page-skills>
      <page-contact></page-contact>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import Vue from "vue";
require ("@/js/my.js");

Vue.component("PageAbout", function(resolve) {
  setTimeout(function() {
    require(["@/views/About"], resolve);
  }, 500);
});
Vue.component("PagePortfolio", function(resolve) {
  setTimeout(function() {
    require(["@/views/Portfolio"], resolve);
  }, 100);
});
Vue.component("PageBlog", function(resolve) {
  setTimeout(function() {
    require(["@/views/Blog"], resolve);
  }, 1500);
});
Vue.component("PageSkills", function(resolve) {
  setTimeout(function() {
    require(["@/views/Skills"], resolve);
  }, 2000);
});
Vue.component("PageContact", function(resolve) {
  setTimeout(function() {
    require(["@/views/Contact"], resolve);
  }, 1000);
});


//import PageBlog from '@/views/Blog.vue';
//import PageSkills from '@/views/Skills.vue';

export default {
  name: "app",
  mounted() {
    this.setTotalPageNumber();
    this.setDataNumberForSections();
    this.setActiveMenuItem();
    this.setSlowScroll();
    this.setMenu();
    //this.setParallax();
  },
  methods:{
    setTotalPageNumber(){
      window.$('.total-pages-num').html(('0' + window.$('.page-wrapper .section').length).slice(-2));
    },
    setDataNumberForSections(){
      var number_pos = 1;
      window.$('.page-wrapper .section').each(function() {
        window.$(this).data('num', ('0' + number_pos).slice(-2));
        number_pos++;
      });
    },
    setActiveMenuItem() {
        var currentSection = null;
        var section_num = window.$('.page-wrapper .section.section-active').data("num");
        window.$('.section').each(function() {
          var element = window.$(this).attr('id');
          if (window.$('#' + element).is('*')) {
            if (window.$(window).scrollTop() >= window.$('#' + element).offset().top - 150) {
              currentSection = element;
            }
          }
        });
        window.$('.nav-menu ul li').removeClass('current').find('a[href*="#' + currentSection + '"]').parent().addClass('current');
        window.$('.page-wrapper .section').removeClass('section-active');
        window.$('#' + currentSection).addClass('section-active');
        if (section_num !== window.$('#' + currentSection).data("num")) {
            section_num = window.$('#' + currentSection).data("num");
            window.$('.current-num span').animate({
              "opacity": '0',
              "left": "-5px"
            }, 150, function() {
              window.$(this).text(section_num).animate({
                "opacity": '1',
                "left": "0"
              }, 150);
            });
        }
    },
    setSlowScroll() {
      window.$('.nav-menu ul li a[href^="#"], a.button, .slow-scroll').on("click", function(e) {
        if (window.$(this).attr('href') === '#') {
          e.preventDefault();
        } else {
          window.$('html, body').animate({
            scrollTop: window.$(this.hash).offset().top
          }, 1500);
          return false;
        }
      });
    },
    setMenu() {
      window.$('.nav-btn').on('click', function() {
        window.$('.nav-btn, .s-nav').toggleClass('active');
        return false;
      });
      if (window.$(window).width() > 1200) {
        window.$('.dropdown').on('mouseenter', function() {
            window.$(this).find('ul').show('ease');
        });
        window.$('.nav-list').on('mouseleave', function() {
            window.$('.dropdown ul').hide('ease');
        });
      } else {
        window.$('.dropdown').on('click', function() {
            window.$(this).find('ul').toggle('ease');
        });
      }
      window.$('.nav-list>li>a').on('click', function() {
          if (window.$(window).width() < 1200) {
            window.$('.s-nav, .nav-btn').toggleClass('active');
          }
      });
    },
  }
}
</script>
<style lang="scss">
@import "@/assets/style/my.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import "@/assets/style/clear.scss";
@import "@/assets/style/main.scss";
@import "@/assets/js/animated/headline.scss";

@keyframes imagen-ini {
  0%   {background-color:red; left:0px; top:0px;}
  25%  {background-color:yellow; left:200px; top:0px;}
  50%  {background-color:blue; left:200px; top:200px;}
  75%  {background-color:green; left:0px; top:200px;}
  100% {background-color:red; left:0px; top:0px;}
}

.imagen-base-ini{
  width: 100px;
  height: 100px;
  background-color: red;
  position: relative;
  animation-name: imagen-ini;
  animation-duration: 4s;
  animation-iteration-count: 3;
}

.imagen-base:hover{
  width: 300px;
}

</style>
